import { cn } from "cn";
import type { LinePrice } from "./line-price";

/**
 * The price cell of a cart line. The discounted state stacks the struck-through
 * original above the price actually charged, so the reduction is visible as a change
 * rather than announced in a caption the price never reflects.
 */
export function LinePriceCell({
  price,
  className,
}: {
  price: LinePrice;
  className?: string;
}) {
  if (price.kind === "included") {
    return (
      <p
        className={cn(
          /* sorted */
          "text-sm leading-5 font-medium",
          className,
        )}
      >
        Included
      </p>
    );
  }

  if (price.kind === "discounted") {
    return (
      <div className={cn("text-right", className)}>
        <p className="text-xs leading-4 text-text-dark-low line-through">
          {price.originalLabel}
        </p>
        <p className="text-sm leading-5 font-medium text-text-success">
          {price.discountedLabel}
        </p>
      </div>
    );
  }

  return (
    <p className={cn("text-sm leading-5 font-medium", className)}>
      {price.label}
    </p>
  );
}
